import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
  useMemo,
} from 'react';

import {
  CreateCompleteVersionDto,
  TaxonomyGetResponse,
} from '@/services/TaxonomiesService';

interface TaxonomyContextValue {
  taxonomiesUpdated: CreateCompleteVersionDto;
  setTaxonomiesUpdated: Dispatch<SetStateAction<CreateCompleteVersionDto>>;
  properties: TaxonomyGetResponse[];
  setProperties: Dispatch<SetStateAction<TaxonomyGetResponse[]>>;
}

interface TaxonomyProviderProps {
  children: ReactNode;
}

export const TaxonomyContext = createContext<TaxonomyContextValue | null>(null);

export function TaxonomyProvider({ children }: TaxonomyProviderProps) {
  const [properties, setProperties] = useState<TaxonomyGetResponse[]>([]);
  const [taxonomiesUpdated, setTaxonomiesUpdated] =
    useState<CreateCompleteVersionDto>({
      data: [],
      taxonomiesToRemove: [],
      version: '',
    });

  const value = useMemo(
    () => ({
      taxonomiesUpdated,
      setTaxonomiesUpdated,
      properties,
      setProperties,
    }),
    [properties, taxonomiesUpdated],
  );

  return (
    <TaxonomyContext.Provider value={value}>
      {children}
    </TaxonomyContext.Provider>
  );
}

export function useTaxonomyContext() {
  const context = useContext(TaxonomyContext);
  if (!context) {
    throw new Error(
      'useTaxonomyContext must be used within a TaxonomyProvider',
    );
  }
  return context;
}
